var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFirstNewProductReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.738 71.1581C140.738 109.593 109.593 140.738 71.1581 140.738C32.7235 140.738 1.57812 109.593 1.57812 71.1581C1.57812 32.7235 32.7235 1.57812 71.1581 1.57812C109.593 1.57812 140.738 32.7235 140.738 71.1581Z",
    fill: "url(#paint0_linear_1545_9255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9255)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3202 24.5947L66.3049 28.4015C66.2302 28.5508 66.1182 28.6254 65.9316 28.6628L61.677 29.4092C60.52 29.5958 59.5497 30.4542 59.1764 31.5738C58.8032 32.6935 59.1018 33.9251 59.9229 34.7835L62.9086 37.8812C63.0206 37.9932 63.0579 38.1424 63.0579 38.2917L62.4607 42.5464C62.2741 43.7033 62.7966 44.8976 63.7297 45.6067C64.7 46.3159 65.969 46.4278 67.014 45.9053L70.8954 44.0019C71.0447 43.9273 71.194 43.9273 71.3433 44.0019L75.2247 45.9053C76.307 46.4278 77.5386 46.3159 78.509 45.6067C79.4794 44.8976 79.9645 43.7407 79.7779 42.5464L79.1808 38.2917C79.1435 38.1424 79.2181 37.9932 79.3301 37.8812L82.3158 34.7835C83.1369 33.9251 83.4354 32.6935 83.0622 31.5738C82.689 30.4542 81.7186 29.5958 80.5617 29.4092L76.307 28.6628C76.1577 28.6254 76.0085 28.5508 75.9338 28.4015L73.9184 24.5947C73.3586 23.5497 72.2763 22.8779 71.082 22.8779C69.9624 22.8779 68.88 23.5124 68.3202 24.5947Z",
    fill: "#C8A262"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9255)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.188 85.5403C104.188 88.2274 102.359 90.2055 100.717 91.9222C99.8214 92.8553 98.9257 93.8256 98.7018 94.5348C98.4634 95.2839 98.5978 96.4679 98.7366 97.6901C98.7499 97.8075 98.7633 97.9252 98.7764 98.043C99.075 100.357 99.3735 103.007 97.8807 105.097C96.3244 107.209 93.7748 107.702 91.4738 108.147L91.4241 108.157C91.2785 108.187 91.132 108.217 90.9856 108.246C89.8562 108.473 88.7388 108.698 88.1771 109.127C87.5728 109.554 86.9686 110.658 86.3643 111.761L86.2737 111.927C85.1914 114.017 83.8851 116.368 81.3846 117.189C80.8247 117.376 80.2276 117.45 79.6678 117.45C77.9218 117.45 76.2439 116.668 74.6989 115.947L74.4801 115.845C73.2858 115.248 72.0169 114.651 71.1585 114.651C70.3001 114.651 69.0685 115.248 67.8368 115.845C65.7468 116.853 63.3583 117.973 60.9324 117.189C58.4318 116.368 57.1629 114.017 56.0432 111.927L55.9526 111.761C55.3484 110.658 54.7441 109.554 54.1398 109.127C53.5054 108.642 52.1991 108.381 50.8929 108.157L50.817 108.142C48.522 107.698 45.9497 107.201 44.4362 105.097C42.9061 103.007 43.242 100.357 43.5405 98.043C43.5524 97.9359 43.5646 97.8286 43.5767 97.7214L43.5769 97.7199C43.7168 96.4821 43.8555 95.2558 43.6152 94.5348C43.409 93.8817 42.6014 93.0071 41.8045 92.1442L41.8045 92.1441L41.803 92.1425C41.735 92.069 41.6672 91.9955 41.5998 91.9222L41.5676 91.8878C39.9701 90.179 38.1289 88.2094 38.1289 85.5403C38.1289 82.8531 39.9577 80.8751 41.5998 79.1583C41.6672 79.085 41.735 79.0116 41.803 78.938L41.8045 78.9364C42.6013 78.0734 43.4089 77.1988 43.6152 76.5458C43.8535 75.7967 43.7191 74.6126 43.5803 73.3904L43.5803 73.3902C43.567 73.2729 43.5536 73.1552 43.5405 73.0375C43.242 70.7236 42.9434 68.0738 44.4362 65.9838C45.9925 63.8717 48.5422 63.3783 50.8432 62.933L50.8929 62.9234C51.0384 62.8934 51.185 62.864 51.3313 62.8345C52.4607 62.6073 53.5782 62.3826 54.1398 61.9531C54.7441 61.5265 55.3484 60.4229 55.9526 59.3194L56.0432 59.1539C57.1256 57.0639 58.4318 54.7127 60.9324 53.8916C63.2823 53.0962 65.5622 54.157 67.6024 55.1062L67.7995 55.1979C68.9938 55.795 70.2627 56.3921 71.1211 56.3921C71.9746 56.3921 73.2339 55.8018 74.4222 55.2448L74.4428 55.2352C76.5328 54.2275 78.9213 53.1079 81.3472 53.8916C83.8851 54.7127 85.154 57.0639 86.2737 59.1539L86.3643 59.3194C86.9686 60.4229 87.5728 61.5265 88.1771 61.9531C88.8115 62.4382 90.1178 62.6995 91.4241 62.9234L91.5 62.9381C93.7949 63.3821 96.3672 63.8797 97.8807 65.9838C99.4109 68.0738 99.075 70.7236 98.7764 73.0375C98.7644 73.1451 98.7522 73.2529 98.7401 73.3607V73.3608C98.6001 74.5985 98.4614 75.8248 98.7018 76.5458C98.908 77.1988 99.7156 78.0734 100.512 78.9364C100.581 79.0105 100.649 79.0845 100.717 79.1583L100.749 79.1927C102.347 80.9015 104.188 82.8711 104.188 85.5403ZM76.1603 80.0541C76.1603 81.323 75.1527 82.3307 73.8837 82.3307L69.5544 82.2934V83.2264H71.1219C72.3909 83.2264 73.3985 84.2341 73.3985 85.503C73.3985 86.772 72.3909 87.7796 71.1219 87.7796H69.5544V88.7127H73.8837C75.1527 88.7127 76.1603 89.7204 76.1603 90.9893C76.1603 92.2582 75.1527 93.2659 73.8837 93.2659H67.3151C66.0462 93.2659 65.0385 92.2582 65.0385 90.9893V80.0541C65.0385 78.7852 66.0462 77.7775 67.3151 77.7775H73.8837C75.1527 77.7775 76.1603 78.7852 76.1603 80.0541ZM60.7469 77.8149C59.4779 77.8149 58.4703 78.8226 58.4703 80.0915V82.8533L56.119 78.9346C55.5965 78.0762 54.5515 77.6283 53.5811 77.9269C52.6108 78.1881 51.9017 79.0839 51.9017 80.1289V91.0641C51.9017 92.333 52.9094 93.3407 54.1783 93.3407C55.4472 93.3407 56.4549 92.333 56.4549 91.0641V88.3023L58.8062 92.221C59.2167 92.9301 59.9631 93.3407 60.7469 93.3407C60.9335 93.3407 61.1574 93.3034 61.344 93.266C62.3144 93.0048 63.0235 92.1091 63.0235 91.0641V80.1289C63.0235 78.8226 62.0158 77.8149 60.7469 77.8149ZM85.8643 80.0915C85.8643 78.8226 86.872 77.8149 88.1409 77.8149C89.4098 77.8149 90.4175 78.8226 90.3429 80.0915V91.0267C90.3429 91.9971 89.7457 92.8928 88.8127 93.1914C88.5888 93.266 88.3275 93.3034 88.1036 93.3034C87.4318 93.3034 86.76 92.9675 86.3122 92.4076L83.737 89.0114L81.1618 92.4076C80.5646 93.1914 79.557 93.5273 78.6239 93.1914C77.7282 92.8555 77.0937 91.9971 77.0937 91.0267V80.0915C77.0937 78.8226 78.1014 77.8149 79.3703 77.8149C80.6393 77.8149 81.647 78.8226 81.647 80.0915V84.3089L81.9455 83.8983C82.8039 82.7787 84.7073 82.7787 85.5657 83.8983L85.8643 84.3089V80.0915Z",
    fill: "#C8A262"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1545_9255)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.1571,
    cy: 71.1581,
    r: 61.3872,
    stroke: "#C8A262",
    strokeWidth: 4.07895
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9255",
    x: 59.0176,
    y: 22.8779,
    width: 24.2031,
    height: 24.9841,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9255",
    x: 38.1289,
    y: 53.6123,
    width: 66.0586,
    height: 65.4714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1545_9255",
    x: 7.73047,
    y: 7.73145,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9255",
    x1: 22.8781,
    y1: 16.7248,
    x2: 124.408,
    y2: 115.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2B589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1B088"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFirstNewProductReview);
export default __webpack_public_path__ + "static/media/IconFirstNewProductReview.2d883931a46dd1c7630c32ce23c9d39a.svg";
export { ForwardRef as ReactComponent };